import { render, staticRenderFns } from "./PageFlash.vue?vue&type=template&id=73885c2a&scoped=true"
import script from "./PageFlash.vue?vue&type=script&lang=js"
export * from "./PageFlash.vue?vue&type=script&lang=js"
import style0 from "./PageFlash.vue?vue&type=style&index=0&id=73885c2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73885c2a",
  null
  
)

export default component.exports